<template>
  <div class="comment-list">
    <div class="comment__item" v-for="(item, index) in commentList" :key="index">
      <div class="comment__user">
        <img :src="fetchImage(item.user.avatar)" :alt="item.name" />
      </div>
      <div class="comment__item__content">
        <div class="comment__item__header">
          <div class="comment__info">
            <p class="comment__user__name">{{ item.name }}</p>
            <p class="comment__item__time">{{ formatDate(item.created_at) }}</p>
          </div>
          <div class="comment__action" v-if="item.user_id === account.id">
            <div class="dropdown dropdown--right">
              <button class="js-dropdown-toggle button button--icon button--dropdown" @click="toggleDropdown">
                <i class="las la-ellipsis-h" style="font-size: 20px;"></i>
              </button>
              <div class="dropdown__inner">
                <div class="dropdown__list">
                  <button class="dropdown__menu" @click="handleDeleteComment(item.id)">削除</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="comment__item__inner" v-html="item.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { fetchImageMixin } from '~/mixins/global'

export default {
  name: 'f-comment-item',
  computed: {
    ...mapState({
      commentList: (state) => state.frontend.proposals.comments,
      proposalId: (state) => state.frontend.proposals.proposalId,
      proposalFrom: (state) => state.frontend.proposals.proposalFrom,
      currentStatus: (state) => state.frontend.proposals.currentStatus,
      account: (state) => state.frontend.auth.user,
    }),
  },
  mixins: [fetchImageMixin],

  methods: {
    ...mapActions({
      deleteComment: 'frontend/proposals/deleteComment',
    }),
    toggleDropdown(e) {
      e.target.parentNode.classList.toggle('open')
    },
    handleDeleteComment(id) {
      const payload = {
        id,
        currentStatus: this.currentStatus,
        body: {
          proposal_id: this.proposalId,
          from: this.proposalFrom,
        },
      }

      this.$notify.delete(
        () => {
          const dropdowns = document.querySelectorAll('.dropdown')
          dropdowns.forEach((dropdown) => {
            dropdown.classList.remove('open')
          })

          return this.deleteComment(payload)
        },
        {
          text: this.$t('messages.delete', { name: 'コメント' }),
        },
      )
    },
  },
}
</script>
